import { getShopRendererApiUrl } from '@fourthwall/env';
import { ApiBase } from '../ApiBase';
class ShopRendererApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getCustomPages = ({ shop_id }) => {
            return this.get(`/shops/${shop_id}/pages`);
        };
        this.getPageLayout = (shopId, themeId, pageId) => {
            return this.get(`/shops/${shopId}/themes/${themeId}/pages/${pageId}`);
        };
        this.getAvailableSectionList = (shopId, themeId, blockId) => {
            const params = new URLSearchParams({ block_id: blockId }).toString();
            return this.get(`/shops/${shopId}/themes/${themeId}/sections?${params}`);
        };
        this.getPage = ({ shop_id, page_id, }) => {
            return this.get(`/shops/${shop_id}/pages/${page_id}`);
        };
        this.createPage = ({ shop_id }, requestBody) => {
            return this.post(`/shops/${shop_id}/pages`, requestBody);
        };
        this.duplicatePage = (pathParams, requestBody) => {
            return this.post(`/shops/${pathParams.shop_id}/pages/${pathParams.page_id}/duplicate`, requestBody);
        };
        this.updatePageSettings = ({ shop_id, page_id }, requestBody) => {
            return this.put(`/shops/${shop_id}/pages/${page_id}`, requestBody);
        };
        this.removePage = ({ shop_id, page_id, }) => {
            return this.delete(`/shops/${shop_id}/pages/${page_id}`);
        };
        this.getSites = ({ shop_id }, queryParams) => {
            return this.get(`/shops/${shop_id}/sites`, queryParams);
        };
        this.getSocialNetworks = (shopId) => {
            return this.get(`/shops/${shopId}/social_networks`);
        };
        this.updateSocialNetwork = (shopId, socialNetworkName, body) => {
            return this.patch(`/shops/${shopId}/social_networks/${socialNetworkName}`, body);
        };
        this.deleteSocialNetwork = (shopId, socialNetworkName) => {
            return this.delete(`/shops/${shopId}/social_networks/${socialNetworkName}`);
        };
        this.createTiktokIntegration = (shopId, body) => {
            return this.post(`/shops/${shopId}/integrations/tiktok`, body);
        };
        this.getTiktokIntegration = (shopId) => {
            return this.get(`/shops/${shopId}/integrations/tiktok`);
        };
        this.removeTiktokIntegration = (shopId) => {
            return this.delete(`/shops/${shopId}/integrations/tiktok`);
        };
        this.updateTiktokIntegration = (shopId, body) => {
            return this.put(`/shops/${shopId}/integrations/tiktok`, body);
        };
        this.createInstagramIntegration = (shopId, body) => {
            return this.post(`/shops/${shopId}/integrations/instagram`, body);
        };
        this.getInstagramIntegration = (shopId) => {
            return this.get(`/shops/${shopId}/integrations/instagram`);
        };
        this.removeInstagramIntegration = (shopId) => {
            return this.delete(`/shops/${shopId}/integrations/instagram`);
        };
        this.createInstagramIntegrationV2 = (shopId, body) => {
            return this.post(`/shops/${shopId}/integrations/instagram_v2`, body);
        };
        this.removeInstagramIntegrationV2 = (shopId) => {
            return this.delete(`/shops/${shopId}/integrations/instagram_v2`);
        };
        this.getInstagramIntegrationV2 = (shopId) => {
            return this.get(`/shops/${shopId}/integrations/instagram_v2`);
        };
        this.duplicateTheme = (pathParams) => {
            return this.post(`/shops/${pathParams.shop_id}/themes/${pathParams.theme_id}/duplicate`);
        };
        this.renameTheme = (shopId, themeId, payload) => {
            return this.put(`/shops/${shopId}/themes/${themeId}`, payload);
        };
        this.deleteTheme = (shopId, themeId) => {
            return this.delete(`/shops/${shopId}/themes/${themeId}`);
        };
        this.getShop = ({ shop_id }) => {
            return this.get(`/shops/${shop_id}`);
        };
        this.getHMAC = (shopId) => {
            return this.get(`/shops/${shopId}/hmac`);
        };
        this.updateHMAC = (shopId) => {
            return this.post(`/shops/${shopId}/hmac`);
        };
        this.updateShop = ({ shop_id }, requestBody) => {
            return this.put(`/shops/${shop_id}`, requestBody);
        };
        this.getThemeChangelog = ({ theme_handle, theme_version, }) => {
            return this.get(`/public/themes/${theme_handle}/${theme_version}/changelog`);
        };
        this.searchPublicSocialNetworks = (pathParams, queryParams) => {
            return this.get(`/public/social_networks/${pathParams.social_network_name}/search`, queryParams);
        };
        this.getIcons = (pathParams) => {
            return this.get(`/shops/${pathParams.shop_id}/icons`);
        };
        this.getMembershipsPostTypes = (pathParams) => {
            return this.get(`/shops/${pathParams.shop_id}/memberships/types/posts`);
        };
        this.getMembershipsPostTags = (pathParams) => {
            return this.get(`/shops/${pathParams.shop_id}/memberships/tags/posts`);
        };
        this.getMembershipsVideoSeries = (pathParams) => {
            return this.get(`/shops/${pathParams.shop_id}/memberships/series/posts`);
        };
        this.getMembershipsPostAccess = (pathParams) => {
            return this.get(`/shops/${pathParams.shop_id}/memberships/access/posts`);
        };
        this.getLinkables = (pathParams, queryParams) => {
            return this.get(`/shops/${pathParams.shop_id}/navigations/linkables`, queryParams);
        };
        this.getLinkable = (pathParams) => {
            return this.get(`/shops/${pathParams.shop_id}/navigations/linkables/${pathParams.type}/${pathParams.id}`);
        };
        this.createSectionBatch = (pathParams, requestBody) => {
            return this.post(`/shops/${pathParams.shop_id}/themes/${pathParams.theme_id}/sections/batch`, requestBody);
        };
    }
}
export const ShopRendererApiClient = new ShopRendererApiClientModel(getShopRendererApiUrl('api'));
